import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
    constructor(private spinner: NgxSpinnerService, private injector: Injector) {}
  
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.spinner.show();
        
        return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {        
             this.spinner.hide();
          }
        }, (err: any) => {
          if (err instanceof HttpErrorResponse) {
            this.spinner.hide();
            if (err.status === 401 || err.status === 403) {
              if (!req.url.includes('/delete_cust_device')) {
                const appService = this.injector.get(AppService);
                appService.signOut();
              }
            }
          }
        }));
    }  
}